<div class="step__card">
  <div class="step__badge" [class.step__badge--right]="badgePosition === 'right'">
    <div class="step__badge-star d-flex align-items-center justify-content-center">
      <div class="step__badge-square"></div>
      <div class="step__badge-square step__badge-square--rotated"></div>
      <span class="step__badge-number fs-1">{{ number }}</span>
    </div>
  </div>
  <h3 class="step__card-title fs-5">{{ title }}</h3>
  <p class="step__card-body mb-0">{{ body }}</p>
</div>
